import { CheckboxFormField, IFormRender, Label, TextFormField } from '@busybusy/webapp-react-ui';
import { Well } from 'components';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'utils/localize';
import { v_require } from 'utils/validations';
import { ICreatePositionsFormData } from '../CreatePositionForm';

export interface ICreatePositionGeneralSectionProps {
  form: IFormRender<ICreatePositionsFormData>;
}

const CreatePositionGeneralSection = ({ form }: ICreatePositionGeneralSectionProps) => (
  <>
    <Label secondaryLabel={t('Required')}>{t('Title')}</Label>
    <TextFormField name="title" form={form} validations={[{ validation: v_require }]} />
    <Well>
      <CheckboxFormField
        name="scopeByGroup"
        form={form}
        label={
          <HeaderText title={t('Limit Permissions to Employee Groups')}>
            <span>
              {t(
                'When enabled, all permissions will only apply to the employees in the same employee group as the employee assigned the position.'
              )}
            </span>
          </HeaderText>
        }
        onChange={(value) => {
          if (value) {
            form.setData('manageEmployeeGroups', false);
          }
        }}
      />
    </Well>
  </>
);
export default CreatePositionGeneralSection;
